import { render, staticRenderFns } from "./TermsAndConditionsYoutube.vue?vue&type=template&id=e9e0811e&"
import script from "./TermsAndConditionsYoutube.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsYoutube.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionsYoutube.vue?vue&type=style&index=0&id=e9e0811e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports